/**
 * Các nền tảng
 */
export default {
  iGOV: 1,
  iHOS: 2,
  iUNI: 3,
};
